const moment = require('moment');
const momentTimezone = require('moment-timezone');
const { momentUTCToLocalDate } = require('./Dates');
const WVValidator = require('./WVValidator');

exports.formatString = (value) => {
  let res = value;
  if (!value || (value.toLowerCase() === 'null')) {
    res = '';
  }
  return res;
};

exports.dealCurrencyCode = (deal) => {
  if (!deal || !deal.dealTerms || !deal.dealTerms.deal_currency_code) {
    return 'USD';
  }
  return deal.dealTerms.deal_currency_code.toUpperCase();
};
exports.getCurrencySymbol = (currency) => {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
  };
  return symbols[currency.toUpperCase()] || currency;
};

exports.formatCurrency = (amount, currency = 'usd', minimumFractionDigits = 2, noCurrencyCode = false) => {
  if (!WVValidator.isNumber(amount)) { return ''; }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits,
  });

  return noCurrencyCode ? formatter.format(amount) : `${currency.toUpperCase()} ${formatter.format(amount)}`;
};

exports.formatCents = (amount, currency = 'usd', minimumFractionDigits = 2, noCurrencyCode = false) => {
  return exports.formatCurrency(amount / 100, currency, minimumFractionDigits, noCurrencyCode);
};

exports.formatNumber = (amount, minimumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
  });

  return formatter.format(amount);
};
exports.formatCompactNumber = (num) => {
  if (num == null) return '-';
  const n = Number(num);
  if (Number.isNaN(n)) return '-';
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
  return n.toString();
};

exports.formatIntNumber = (amount, maximumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });

  return formatter.format(amount);
};

exports.formatIntNumberAndAddPercentSign = (amount) => {
  const formatterPercent = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatterPercent.format(amount);
};

exports.formatIntNumberWithPercent = (amount, total) => {
  const formatterNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
  });
  const formatterPercent = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
  });
  let percent = 0;
  if (total > 0) {
    percent = amount / total;
  }

  return `${formatterNumber.format(amount)} (${formatterPercent.format(percent)})`;
};

exports.roundToInt = (value) => {
  const decimal = value % 1; // Get the decimal part of the percentage
  if (decimal >= 0.5) {
    return Math.ceil(value); // Round up
  }
  return Math.floor(value); // Round down
};

exports.formatDateForCreatorsPaymentsTables = (date, format = 'M/D/YYYY h:mm A') => {
  if (date) {
    const utc = moment.utc(new Date(date));
    const local = moment(utc).local();
    return local.format(format);
  }
  return '-';
};
exports.formatDateInUTC = (date, format='MM/DD/YYYY') => {
  if (!date) { return ''; }
  return moment.utc(date).format(format);
};

exports.fillUrl = value => (!value || /^https?:/.test(value) ? value : `https://${value}`);
const formatToEST = momentO => (momentO.tz ? momentO.tz('America/New_York') : momentO.utcOffset('-04:00'));
exports.formatToEST = formatToEST;
exports.getServerDate = date => momentUTCToLocalDate(moment(date)).format('MM/DD/YY');
exports.getServerDateTime = (datetime, format) => (datetime ? moment(datetime).format(format || 'M/D/YY h:mma') : '');
exports.formatToMT = (date, format) =>
  (momentTimezone.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), 'America/Denver').isDST()
    ? moment(date).utcOffset('-06:00').format(format || 'M/D/YY h:mma')
    : moment(date).utcOffset('-07:00').format(format || 'M/D/YY h:mma'));
exports.getFormattedDate = date => moment(date).format('M/DD/YYYY');
exports.getFormattedDateNoZeroes = date => moment(date).format('M/D/YYYY');
exports.formatDate = date => (date ? formatToEST(moment(date))?.format('M/D/YY') : '');
exports.formatDateByMonthAndYear = date => {
    if (!date) return '';
    const estDate = moment(date);
    return estDate ? estDate.format('MMMM YYYY') : '';
};
exports.capitalize = n => `${n.charAt(0).toUpperCase()}${n.slice(1)}`;
exports.formatCheckedOption = value => (value ? 'Yes' : 'No');
exports.s = k => (k !== 1 ? 's' : '');

exports.normalizeUrl = (url) => {
  // Insures that there is 'https://wwww' in front of the url string
  if (!url) {
    return '';
  }

  let updatedUrl = url;

  // If the URL does not start with "http://" or "https://"
  if (url.startsWith('http://')) {
    updatedUrl = url.replace('http://', 'https://');
  }

  if (!updatedUrl.startsWith('https://')) {
    updatedUrl = `https://${url}`;
  }

  // Find where the domain starts by locating the "://", if present
  const domainStart = updatedUrl.indexOf('://') > -1 ? updatedUrl.indexOf('://') + 3 : 0;

  // Check if the URL contains "www." after the protocol
  if (!updatedUrl.substring(domainStart).startsWith('www.')) {
    // If "www." is not present, insert it after the protocol
    updatedUrl = `${updatedUrl.slice(0, domainStart)}www.${updatedUrl.slice(domainStart)}`;
  }

  return updatedUrl;
};
